import React from 'react';
import TaskFileCardEngine from '../engine/TaskFileCardEngine';

const TaskFilesView = props => {
  return (
    <div>
      {props.files.map((one, k) => {
        return (
          <TaskFileCardEngine
            key={one.strippedFilename + k}
            displayFilename={one.displayFilename}
            filename={one.strippedFilename}
            encodedFilename={one.encodedFilename}
            onFileDeleted={() => props.onFileDeleted(one)}
            size={one.size}
            taskId={props.taskId}
            viewOnly={props.viewOnly}
          />
        );
      })}
    </div>
  );
};

export default TaskFilesView;
